var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#00A68B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_11210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 24C33 22.22 32.4722 20.4799 31.4832 18.9999C30.4943 17.5198 29.0887 16.3663 27.4442 15.6851C25.7996 15.0039 23.99 14.8257 22.2442 15.1729C20.4984 15.5202 18.8947 16.3774 17.636 17.636C16.3774 18.8947 15.5202 20.4984 15.1729 22.2442C14.8257 23.99 15.0039 25.7996 15.6851 27.4442C16.3663 29.0887 17.5198 30.4943 18.9999 31.4832C20.4799 32.4722 22.22 33 24 33",
    stroke: "#00A68B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 21H32.4",
    stroke: "#00A68B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 27H23.5",
    stroke: "#00A68B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15C21.8153 17.6996 20.9222 20.8179 20.9222 24C20.9222 27.1821 21.8153 30.3004 23.5 33",
    stroke: "#00A68B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15C26.1172 17.5897 27.0064 20.5675 27.074 23.62",
    stroke: "#00A68B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 30C27 30.7956 27.3161 31.5587 27.8787 32.1213C28.4413 32.6839 29.2044 33 30 33C30.7956 33 31.5587 32.6839 32.1213 32.1213C32.6839 31.5587 33 30.7956 33 30C33 29.2044 32.6839 28.4413 32.1213 27.8787C31.5587 27.3161 30.7956 27 30 27C29.2044 27 28.4413 27.3161 27.8787 27.8787C27.3161 28.4413 27 29.2044 27 30Z",
    stroke: "#00A68B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2 32.2002L34 34.0002",
    stroke: "#00A68B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_11210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeSearch);
export default __webpack_public_path__ + "static/media/globe_search.e63a3ea1.svg";
export { ForwardRef as ReactComponent };